export default "__VITE_ASSET__Bl$VvDl6__"